import React from "react";
import { useNavigation } from "hooks/useNavigation";

import "./index.scss";
import { BackCloseButtonProps } from "models/BackCloseButton";

import ArrowRight from "assets/icon/arrow-left.svg";
import Close from "assets/icon/close.svg";

import { ReactSVG } from "react-svg";

const BackCloseButton = ({
  navigationPath,
  closeIcon,
}: BackCloseButtonProps) => {
  const navigate = useNavigation();

  const navigation = () =>
    navigationPath ? navigate(navigationPath) : navigate(-1);

  return (
    <ReactSVG
      src={closeIcon ? Close : ArrowRight}
      className="back-close-btn circle-icon"
      onClick={navigation}
    />
  );
};

export default BackCloseButton;
